import API, { AUTH_HEADER_ROOMS, AUTH_HEADER } from 'base/api';
import { omit } from 'lodash';
import { fetchUserData } from 'modules/User/redux/fetchUserData';
import auth, { STORAGE_ROOMS_TOKEN } from 'base/auth';

export const UPDATE_ROOM = 'UPDATE_ROOM';
export const UPDATE_ROOM_BEGIN = 'UPDATE_ROOM_BEGIN';
export const UPDATE_ROOM_SUCCESS = 'UPDATE_ROOM_SUCCESS';
export const UPDATE_ROOM_ERROR = 'UPDATE_ROOM_ERROR';

export const updateRoomBegin = () => ({
  type: UPDATE_ROOM_BEGIN
});

export const updateRoomSuccess = ( data ) => ({
  type: UPDATE_ROOM_SUCCESS,
  payload: { data }
});

export const updateRoomError = ( error ) => ({
  type: UPDATE_ROOM_ERROR,
  payload: { error }
});

export function updateRoom (roomId, newRoomers){
  console.log(newRoomers)
  console.log(JSON.stringify(newRoomers))
  return dispatch => {
    dispatch(updateRoomBegin());
    return fetch(API.UPDATE_ROOM + roomId, {
      method: 'POST',
      body: JSON.stringify(newRoomers),
      headers: new Headers(AUTH_HEADER_ROOMS)
    })
      .then(handleErrors)
      .then(res => {
        return res.json()
      })
      .then(json => {
        dispatch(updateRoomSuccess(json));
        // console.log('UPDETED', json)

        if (json.code === '010' && newRoomers.newRoomers.length > 0)
          dispatch(fetchUserData(auth.getToken(STORAGE_ROOMS_TOKEN)))
        return json;
      })
      .catch(error => dispatch(updateRoomError(error.message)));
  };
}

function handleErrors(response) {
  if (!response.ok) {
    // console.log('error')
    throw Error(response.statusText);
  }
  return response;
}



// WEBPACK FOOTER //
// ./src/modules/User/redux/updateRoom.js